import { FC, useEffect } from 'react';

import { Button, Headline, Layout, Page, Stack } from '@servicetitan/design-system';

import { environment } from '../../api';
import { PageSpinner } from '../../common';

const ProductionLoginPage: FC = () => {
    const createLoginButton = (environmentName: string, hostName: string) => (
        <Button
            primary
            outline
            onClick={() => {
                window.location.assign(
                    `https://${hostName}.servicetitan.io/auth/login?returnUrl=/`,
                );
            }}
        >
            {`Sign In as ${environmentName} Environment User`}
        </Button>
    );

    const createIntegrationLoginButton = () =>
        createLoginButton('Integration', 'tenant-api-credentials-portal-integration');

    const createProductionLoginButton = () =>
        createLoginButton('Production', 'tenant-api-credentials-portal');

    return (
        <Page
            header={
                <Headline el="h1" size="large">
                    Sign In
                </Headline>
            }
        >
            <Layout type="2Col">
                <Layout.Section>
                    <Stack direction="column" spacing={2}>
                        <Stack.Item>
                            <Headline el="h2" size="medium">
                                Third-Party Developers
                            </Headline>
                        </Stack.Item>
                        <Stack.Item>{createIntegrationLoginButton()}</Stack.Item>
                    </Stack>
                </Layout.Section>
                <Layout.Section>
                    <Stack direction="column" spacing={2}>
                        <Stack.Item>
                            <Headline el="h2" size="medium">
                                ServiceTitan Customers
                            </Headline>
                        </Stack.Item>
                        <Stack.Item>{createIntegrationLoginButton()}</Stack.Item>
                        <Stack.Item>{createProductionLoginButton()}</Stack.Item>
                    </Stack>
                </Layout.Section>
            </Layout>
        </Page>
    );
};
ProductionLoginPage.displayName = 'ProductionLoginPage';

const NonProductionLoginPage: FC = () => {
    useEffect(() => {
        window.location.replace('/auth/login?returnUrl=/');
    });

    return <PageSpinner />;
};
NonProductionLoginPage.displayName = 'NonProductionLoginPage';

export const LoginPage = environment.site.isProduction
    ? ProductionLoginPage
    : NonProductionLoginPage;
